const CIConstants = {
  common: {
    ZERO: 0,
    colors: {
      CI_BG: '#f7f7f7',
      CI_BLUE: '#3F51B5',
      CI_CYAN: '#4990E2',
      CI_GREEN: '#009688',
      CI_NAVI: '#607D88',
      CI_TEXT: '#4C4C4C',
      CI_RED: '#F44336',
      CI_PINK: '#E91E63',
      CI_ORANGE: '#EE5D2F',
      CI_LTGREEN: '#4CAF50',
      CI_LTLTGREEN: '#7FCAC3',
      CI_LTBLUE: '#33C2D8',
      CI_LTGRAY: '#ADADAD',
      CI_WHITE: '#fff',
      CI_BLACK: '#000',
      CI_LTLTGRAY: '#EFEFEF',
      CI_LTLTBLUE: '#bac5ff',
      CI_GRAYLIGHTMEDIUM: '#9e9e9e'
    },
    SIGN_OUT: 'SIGN_OUT',
    dates: {
      jsweekdaysnumeric: {
        SATURDAY: 6,
        SUNDAY: 0
      }
    }
  },
  time: {
    ONE_DAY_IN_MILLISECONDS: 24 * 60 * 60 * 1000,
    ONE_MINUTE_IN_MILLISECONDS: 60 * 1000
  },
  // menu and Frenchmenu removed. Use language context for dynamic menu.
  calendar: {
    CONTAINER_MIN_WIDTH: 826,
    CALENDAR_MIN_DAYS: 16,
    CALENDAR_MAX_DAYS: 45,
    RESIZE_DIFF: 17,
    DAY_MIN_LENGTH: 25,
    MIN_ACTIVITY_LENGTH: 0.25,
    activities: {
      LENGTH_500: 500,
      LENGTH_510: 510,
      LENGTH_540: 540
    },
    vacation: {
      RESET_BTN: 'RESET'
    }
  },
  openTimeSearch: {
    TOTAL_OPTIONS: 4,
    OPTIONS_MULTIPLE: 25,
    MINIMUM_ITEMS: 10,
    filter: {
      AUTOCOMPLETE: {
        HEIGHT: 250
      }
    },
    operators: ['', 'BEFORE', 'EQUALS', 'AFTER'],
    operatorsRange: ['GREATER_THAN', 'EQUALS', 'LOWER_THAN'],
    sort: {
      ACTIVITY_TYPE: 'ACTIVITY_TYPE',
      NAME: 'NAME',
      START_DATE: 'START_DATE',
      END_DATE: 'END_DATE',
      CREDIT: 'CREDIT',
      BID_ANALYSIS_RANK: 'BID_ANALYSIS_RANK',
      LAYOVER: 'LAYOVER'
    },
    sortArray: [
      {
        STRING: 'OUTBID',
        IDENTIFIER: 'OUTBID',
        CLASSNAME: 'small-1 columns outbid',
        SORTABLE: false
      },
      {
        STRING: 'ACTIVITY_TYPE',
        IDENTIFIER: 'Activity Type',
        CLASSNAME: 'small-1 columns Activity Type',
        SORTABLE: true
      },
      {
        STRING: 'NAME',
        IDENTIFIER: 'Name',
        CLASSNAME: 'small-1 columns Name',
        SORTABLE: true
      },
      {
        STRING: 'START_DATE',
        IDENTIFIER: 'Start Date',
        CLASSNAME: 'small-2 columns Start Date',
        SORTABLE: true
      },
      {
        STRING: 'END_DATE',
        IDENTIFIER: 'End Date',
        CLASSNAME: 'small-2 columns End Date',
        SORTABLE: true
      },
      {
        STRING: 'CREDIT',
        IDENTIFIER: 'Credit',
        CLASSNAME: 'small-1 columns Credit',
        SORTABLE: true
      },
      {
        STRING: 'BID_ANALYSIS_RANK',
        IDENTIFIER: 'Analyzer Rank',
        CLASSNAME: 'small-1 columns Analyzer Rank ',
        SORTABLE: true,
        HANDLE_REFRESH: true
      },
      {
        STRING: 'LAYOVER',
        IDENTIFIER: 'Layover',
        CLASSNAME: 'small-1 columns Layover',
        SORTABLE: true
      },
      {
        STRING: 'DEAD_HEAD',
        IDENTIFIER: 'DH',
        CLASSNAME: 'small-1 columns DH end',
        SORTABLE: false
      }
    ],
    sortCriteria: {
      CLASSNAME_ASCENDING: 'ion ion-arrow-up-b',
      CLASSNAME_DESCENDING: 'ion ion-arrow-down-b'
    },
    ASCENDING: 'ASCENDING',
    DESCENDING: 'DESCENDING',
    values: {
      ZERO: 0,
      DOUBLE_ZERO: '00',
      ONE: 1,
      TWO: 2,
      THREE: 3,
      STEP: 15,
      HOUR_LIMIT: 1000,
      MINUTE_LIMIT: 59,
      SIXTY: 60
    }
  },
  pairings: {
    TYPES: {
      LAYOVER: 'LAYOVER',
      LEG: 'LEG'
    },
    FLIGHTS: {
      ACTIVE: 'A',
      DEADHEAD: 'D'
    }
  },
  PROPERTIES: {
    SCORE_PROPERTY_ID: 13
  },
  MOCK_MODE: false,
  BREAK_POINT_LARGE: '1280px',
  JWTOKEN: 'jwToken',
  STAFFID: 'staffId',
  CATEGORY_ID: 'categoryId',
  STATION_ID: 'stationId',
  STDBIDSESSION_ID: 'standingBidSessionId',
  LVBSID: 'lastViewedBidSessionId',
  AUTHORIZATION_REQUEST_HANDLE_KEY: 'appauth_current_authorization_request',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  AUTHORIZATION_SUCCESS: 'Authorization_Success',
  APPAUTH_SUFFIX: 'appauth_',
  REGULAR_BID_SCOPE: 'Regular',
  RESERVE_BID_SCOPE: 'Reserve',
  LAST_BID_SCOPE_USE: 'lastBidScopeUsed',
  httpStatus: {
    ACCEPTED: 202,
    BAD_GATEWAY: 502,
    BAD_REQUEST: 400,
    CONFLICT: 409,
    CONTINUE: 100,
    CREATED: 201,
    EXPECTATION_FAILED: 417,
    FAILED_DEPENDENCY: 424,
    FORBIDDEN: 403,
    GATEWAY_TIMEOUT: 504,
    GONE: 410,
    HTTP_VERSION_NOT_SUPPORTED: 505,
    INSUFFICIENT_SPACE_ON_RESOURCE: 419,
    INSUFFICIENT_STORAGE: 507,
    INTERNAL_SERVER_ERROR: 500,
    LENGTH_REQUIRED: 411,
    LOCKED: 423,
    LOGIN_TIME_OUT: 440,
    METHOD_FAILURE: 420,
    METHOD_NOT_ALLOWED: 405,
    MOVED_PERMANENTLY: 301,
    MOVED_TEMPORARILY: 302,
    MULTI_STATUS: 207,
    MULTIPLE_CHOICES: 300,
    NETWORK_AUTHENTICATION_REQUIRED: 511,
    NO_CONTENT: 204,
    NON_AUTHORITATIVE_INFORMATION: 203,
    NOT_ACCEPTABLE: 406,
    NOT_FOUND: 404,
    NOT_IMPLEMENTED: 501,
    NOT_MODIFIED: 304,
    OK: 200,
    PARTIAL_CONTENT: 206,
    PAYMENT_REQUIRED: 402,
    PERMANENT_REDIRECT: 308,
    PRECONDITION_FAILED: 412,
    PRECONDITION_REQUIRED: 428,
    PROCESSING: 102,
    PROXY_AUTHENTICATION_REQUIRED: 407,
    REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
    REQUEST_TIMEOUT: 408,
    REQUEST_TOO_LONG: 413,
    REQUEST_URI_TOO_LONG: 414,
    REQUESTED_RANGE_NOT_SATISFIABLE: 416,
    RESET_CONTENT: 205,
    SEE_OTHER: 303,
    SERVICE_UNAVAILABLE: 503,
    SWITCHING_PROTOCOLS: 101,
    TEMPORARY_REDIRECT: 307,
    TOO_MANY_REQUESTS: 429,
    UNAUTHORIZED: 401,
    UNPROCESSABLE_ENTITY: 422,
    UNSUPPORTED_MEDIA_TYPE: 415,
    USE_PROXY: 305
  },
  bidPreferences: {
    totalEntries: 4,
    start: 0,
    end: 4,
    entries: [
      {
        bidSessionId: 33,
        staffId: 302,
        employeeBidId: 38,
        bidAggregateId: 361,
        bidSessionSnapshotId: null,
        score: 1,
        name: 'Desire morning starts 1',
        parameterValues: [
          {
            parameterValueId: 272,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 1081,
            value: '2014-06-01',
            sequence: 1
          },
          {
            parameterValueId: 271,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 1082,
            value: '2014-06-05',
            sequence: 2
          }
        ]
      },
      {
        bidSessionId: 33,
        staffId: 302,
        employeeBidId: 38,
        bidAggregateId: 362,
        bidSessionSnapshotId: null,
        score: 2,
        name: 'Desire morning starts 2',
        parameterValues: [
          {
            parameterValueId: 273,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 2151,
            value: 3,
            sequence: 1
          }
        ]
      },
      {
        bidSessionId: 33,
        staffId: 302,
        employeeBidId: 38,
        bidAggregateId: 363,
        bidSessionSnapshotId: null,
        score: 3,
        name: 'Desire morning starts 3',
        parameterValues: [
          {
            parameterValueId: 275,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 2161,
            value: '2014-06-16',
            sequence: 1
          },
          {
            parameterValueId: 274,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 2162,
            value: '2014-06-18',
            sequence: 2
          }
        ]
      },
      {
        bidSessionId: 33,
        staffId: 302,
        employeeBidId: 38,
        bidAggregateId: 364,
        bidSessionSnapshotId: null,
        score: 4,
        name: 'Desire morning starts 4',
        parameterValues: [
          {
            parameterValueId: 276,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 2171,
            value: '2014-06-26',
            sequence: 1
          }
        ]
      },
      {
        bidSessionId: 33,
        staffId: 302,
        employeeBidId: 38,
        bidAggregateId: 361,
        bidSessionSnapshotId: null,
        score: 5,
        name: 'Desire morning starts 5',
        parameterValues: [
          {
            parameterValueId: 272,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 1081,
            value: '2014-06-01',
            sequence: 1
          },
          {
            parameterValueId: 271,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 1082,
            value: '2014-06-05',
            sequence: 2
          }
        ]
      },
      {
        bidSessionId: 33,
        staffId: 302,
        employeeBidId: 38,
        bidAggregateId: 362,
        bidSessionSnapshotId: null,
        score: 6,
        name: 'Desire morning starts 6',
        parameterValues: [
          {
            parameterValueId: 273,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterId: 2151,
            value: 3,
            sequence: 1
          }
        ]
      }
    ]
  },
  BID_TYPES: {
    REGULAR: 0,
    DEFAULT: 1,
    RESERVE: 15
  },
  BID_CLASSES_CAROUSEL: {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    combinedPreferencesSlidesToShow: 3,
    slidesToScroll: 2,
    combinedPreferencesSlidesToScroll: 3,
    slidesToShowSmallCreen: 2
  },

  RESERVE_DOWN_TO: {
    minLevel: 0,
    maxLevel: 30, // does not take into consideration the 'Any' level, which is assigned to the option level 500.
    levelAny: 500,
    levelNonReserveDownTo: 505,
    levelAnyText: 'Any'
  },

  CLASSES_TO_SHOW: 10,
  UNKNOWN_ATTRIBUTE_ID: 21,
  KINDOFBID: {
    LINECREDIT_PREFERENCE_ID: [533],
    PARAMETERS_WITH_KEY_VALUE_IDS: [7611],
    REGION_PARAMETERS_ID: [4181],
    PERIOD_OF_DATES_OFF_PREFERENCE_ID: 216,
    STATION_LAYOVER_ON_DATES_PREFERENCE_ID: 404,
    STRING_OF_DATES_OFF_PREFERENCE_ID: 108,
    PAIRING_START_ON_DATE: 132,
    SPECIFIC_PAIRING_ON_DATES: 234,
    SPECIFIC_PAIRING_STARTING_ON_DATES: 784,
    TIMEOFF_PARAMETERS_IDS: [371, 372],
    PARING_LAYOVER_PARAMETERS_IDS: [452, 451],
    PARAMETER_CHECK_RENDER_IDS: [5331, 4521, 4511],
    PARAMETER_PARTIAL_OFF: [3712, 3722],
    NO_WEIGHT_DISPLAY_BIDS: [290],
    PAIRING_ATTR_LIST: [679, 680, 681],
    COMBINED_PREFERENCE_EDIT_DISABLED_OPTION_ID: 214,
    LIMIT_ONE_BID_PER_GROUP: 203,
    NOT_DISABLE_ADD_BID_TO_COMBINED: [213, 214, 618, 773, 130, 147, 148, 256, 534, 541, 540, 777],
    PAIRING_ATTRIBUTES_NOT_DISABLE: [678, 679, 680]
  },
  COMPONENTS: {
    INIT_STATION: 'Any',
    WISH_SEQUENCE: 9,
    RELATION_SEQUENCE: 8,
    MAXNN_SEQUENCE: 10
  },
  VALID_RELATIONS: {
    GREATER_THAN: 'GREATER_THAN_RELATION_CODE',
    LESS_THAN: 'LESS_THAN_RELATION_CODE',
    BETWEEN: 'BETWEEN_RELATION_CODE',
    EQUAL: 'EQUAL_RELATION_CODE'
  },
  ADD_REQUEST: {
    DAY_OFF: {
      parameterValues: [
        {
          parameterRelation: 'EQUAL_RELATION_CODE',
          parameterId: 2171,
          value: null,
          parameterSequence: 1
        }
      ],
      preferenceOptionId: 217,
      wish: true
    },
    PAIRING_NUMBER_ON_DATE: {
      parameterValues: [
        {
          parameterRelation: 'EQUAL_RELATION_CODE',
          parameterId: 7841,
          value: null,
          parameterSequence: 1
        },
        {
          parameterRelation: 'EQUAL_RELATION_CODE',
          parameterId: 7842,
          value: null,
          parameterSequence: 2
        },
        {
          parameterRelation: 'EQUAL_RELATION_CODE',
          parameterId: 7843,
          value: null,
          parameterSequence: 3
        }
      ],
      preferenceOptionId: 784,
      wish: true
    },
    PAIRING_START_ON_DATE: {
      parameterValues: [
        {
          parameterRelation: 'EQUAL_RELATION_CODE',
          parameterId: 1321,
          value: null,
          parameterSequence: 1
        },
        {
          parameterRelation: 'EQUAL_RELATION_CODE',
          parameterId: 1322,
          value: null,
          parameterSequence: 2
        }
      ],
      preferenceOptionId: 132,
      wish: true
    },
    RESERVE_NUMBER: {
      parameterValues: [
        {
          parameterRelation: 'EQUAL_RELATION_CODE',
          parameterId: 7601,
          value: null,
          parameterSequence: 1
        }
      ],
      preferenceOptionId: 760,
      wish: true
    }
  },
  HISTORY: {
    NO_BIDS_MESSAGE: 'There is no closed bid sessions yet',
    TITLE: 'History',
    SUBTITLE: 'View your past bid sessions'
  },
  REPORTS: {
    CLEAN_TIME_OUT: 300
  },
  CREW: {
    CAPTAIN: 'CA',
    FO: 'FO'
  },
  LANGUAGE: {
    DEFAULT_LANG: 'EN',
    FRENCH: 'fr',
    LANG_KEY: 'lng',
    EMPTY: '',
    UNDEFINED: 'undefined',
    NULL: 'null'
  },
  LOADSTANDING_KEY: 'chk',
  DISPLAY_ADD_DAY_OFF_ID: 217,
  DISPLAY_REQUEST_ALL_ID: 132,
  LINE_CREDITS_ID: 533,
  DEBOUNCE_DELAY: 1000

};

module.exports = CIConstants;
